module.exports = __webpack_public_path__ + "static/img/allRisksTab.5a05976.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/allRisksTab.jpg
// module id = wFCb
// module chunks = 4